import * as React from 'react';
import { st, classes } from './Divider.st.css';
export var Divider = function (props) { return (React.createElement("div", { className: st(classes.root, props.className), "data-hook": props['data-hook'] })); };
//# sourceMappingURL=Divider.js.map